/* ============================================================================
   NEOGEN — PDP hero gallery enhancer
   Ported 2026-07-07 (Sonnet 5 liquid sprint) from
   codex-handoffs/outbound/2026-05-31-signature-pdp-mockup.html.

   This is the CURRENT gallery behavior: cover-fill crossfade, per-image
   progress bar + bottom scrim, prev/next nav, autoplay (pauses on
   hover/focus, reduced-motion safe), and thumb-click to jump. It supersedes
   the dead legacy click-swap script that shipped earlier in the same mockup
   (simple `img.src = thumb.src` on click, no crossfade/autoplay/nav) — that
   script was NOT ported; do not reintroduce it.

   Frames come from each thumb's data-gallery-src / -srcset / -sizes / -alt
   (sections/neogen-pdp-hero.liquid renders these from product.media). The
   primary <img> is frame 0; a thumb whose data-gallery-src matches it is
   bound to that frame rather than added twice.
   ============================================================================ */
(function () {
  'use strict';
  var DELAY = 4600;

  function init(rail) {
    if (rail.getAttribute('data-ng-enhanced')) return;
    rail.setAttribute('data-ng-enhanced', '1');

    var media = rail.parentNode;
    var primary = media.querySelector('[data-gallery-main]');
    var baseImg = primary && primary.querySelector('img');
    if (!primary || !baseImg) return;

    var raw = [].slice.call(rail.querySelectorAll('[data-gallery-src]'));
    var thumbs = raw.map(function (t) {
      var c = t.cloneNode(true);
      t.parentNode.replaceChild(c, t);
      return c;
    });

    var frames = [];
    function add(src, alt, thumb) {
      if (!src) return;
      var existing = null;
      frames.forEach(function (f) { if (f.src === src) existing = f; });
      if (existing) {
        if (thumb && !existing.thumb) existing.thumb = thumb;
        return;
      }
      frames.push({
        src: src, alt: alt || '', thumb: thumb || null,
        srcset: thumb ? thumb.getAttribute('data-gallery-srcset') || '' : baseImg.getAttribute('srcset') || '',
        sizes: thumb ? thumb.getAttribute('data-gallery-sizes') || '' : baseImg.getAttribute('sizes') || ''
      });
    }
    add(baseImg.getAttribute('src'), baseImg.getAttribute('alt'), null);
    thumbs.forEach(function (t) {
      var im = t.querySelector('img');
      add(t.getAttribute('data-gallery-src') || (im && im.getAttribute('src')), t.getAttribute('data-gallery-alt'), t);
    });
    if (frames.length < 2) return;

    baseImg.classList.add('ng-fade');
    var layerB = baseImg.cloneNode(false);
    layerB.removeAttribute('width');
    layerB.removeAttribute('height');
    layerB.removeAttribute('fetchpriority');
    layerB.classList.add('ng-fade');
    layerB.style.opacity = '0';
    baseImg.parentNode.appendChild(layerB);

    var top = baseImg, bottom = layerB, idx = 0, timer = null, engaged = false;

    var scrim = document.createElement('div');
    scrim.className = 'ng-scrim';
    primary.appendChild(scrim);

    var prog = document.createElement('div');
    prog.className = 'ng-prog';
    var bar = document.createElement('span');
    prog.appendChild(bar);
    primary.appendChild(prog);

    function engage() { engaged = true; stop(); } /* permanent pause once the user takes control */

    function mkNav(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ng-nav ng-nav--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' +
        (dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') +
        '" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        engage();
        paint(idx + dir);
      });
      return b;
    }
    primary.appendChild(mkNav(-1, 'Previous image'));
    primary.appendChild(mkNav(1, 'Next image'));

    function cue() {
      bar.style.transition = 'none';
      bar.style.width = '0%';
      void bar.offsetWidth;
      bar.style.transition = 'width ' + DELAY + 'ms linear';
      bar.style.width = '100%';
    }
    function freeze() {
      var w = getComputedStyle(bar).width;
      bar.style.transition = 'none';
      bar.style.width = w;
    }
    function paint(i) {
      idx = (i + frames.length) % frames.length;
      var f = frames[idx];
      // Clear the previous frame's responsive candidates when returning to a single-source image.
      if (f.sizes) bottom.setAttribute('sizes', f.sizes);
      else bottom.removeAttribute('sizes');
      if (f.srcset) bottom.setAttribute('srcset', f.srcset);
      else bottom.removeAttribute('srcset');
      bottom.src = f.src;
      bottom.alt = f.alt;
      void bottom.offsetWidth;
      bottom.style.opacity = '1';
      top.style.opacity = '0';
      var tmp = top; top = bottom; bottom = tmp;
      thumbs.forEach(function (x) { x.classList.remove('is-active'); x.removeAttribute('aria-current'); });
      if (f.thumb) { f.thumb.classList.add('is-active'); f.thumb.setAttribute('aria-current', 'true'); }
      cue();
    }
    function start() { if (engaged || timer) return; cue(); timer = setInterval(function () { paint(idx + 1); }, DELAY); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } freeze(); }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e && e.preventDefault) e.preventDefault();
        var im = t.querySelector('img');
        var src = t.getAttribute('data-gallery-src') || (im && im.getAttribute('src'));
        var fi = -1;
        frames.forEach(function (f, k) { if (f.src === src) fi = k; });
        engage();
        paint(fi < 0 ? 0 : fi);
      });
    });

    media.addEventListener('mouseenter', stop);
    media.addEventListener('mouseleave', start);
    media.addEventListener('focusin', stop);
    media.addEventListener('focusout', start);

    if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) start();
  }

  function boot() {
    document.querySelectorAll('[data-gallery-rail]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
